<template>
  <mp-flex p="2" gap="3" align-items="center" cursor="pointer" border-bottom="1px" border-color="gray.100" position="relative" class="member-item">
    <avatar :name="name" :url="avatar" />
    <mp-box>
      <mp-text> {{ name }}</mp-text>
      <mp-text font-size="sm" color="gray.600">
        <slot name="description">{{ id }} - {{ title }}</slot>
      </mp-text>
    </mp-box>
    <mp-box class="icon" py="2" pl="2" bg-color="ice.50">
      <mp-icon variant="duotone" :name="icon" ml="auto" />
    </mp-box>
  </mp-flex>
</template>

<script>
import Avatar from '@/components/Avatar';

export default {
  name: 'MemberItem',
  components: {
    Avatar,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    avatar: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'add-circular',
    },
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
.member-item {
  &:hover {
    background-color: var(--colors-ice-50);
    .icon {
      display: block;
    }
  }
  .icon {
    display: none;
    position: absolute;
    right: var(--space-3);
  }
}
</style>
